export const WILDCARD_ORIGIN = '*';
